export default {
    buttons: {
        back: "Z powrotem",
        next: "Następny",
        submit: "Składać"
    }
}